module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABGdBTUEAALGPC/xhBQAAAJlJREFUOBGtVIsKwCAIjPWR+8L+cuDOKKjwCQlSy7tzzmYhogpv8LckjTmDW8vYYKEPHhZj7OBgocZC60FITOWoAaFUF+sCIBrB9NwW0IoJLy5nTYtMZYHITWALNWPqSGW6Is/Gvv2A9OfdypcmiLDoKWz/ARbBim1fJAJ0MS5gSali1cBCPrciB4c8i9hSlw34tQF9jFwZbD/FIyr3lmk4YgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/all_popup_icon_delete.png
// module id = Gd9p
// module chunks = 1